module.exports = __webpack_public_path__ + "static/media/Combined Shape.a0c6c691.svg";